import { useState } from "react";
import { TICKET_SEARCH_QUERY } from "../Queries/TicketSearchQuery";
import { useLazyQuery } from "@apollo/client";

export const useTicketSearch = (user, responseErrorHandler, setShowModal) => {
  const [searchResults, setSearchResults] = useState(null);
  const [resultsPerPage, setResultsPerPage] = useState(25);

  const [searchTickets, { loading: ticketSearchLoading, error: ticketSearchError }] = useLazyQuery(TICKET_SEARCH_QUERY, {
    context: { serializationKey: "incidentQueue" },
    variables: { originatorId: user?.id },
    fetchPolicy: 'no-cache',
    // onError: (error) => { console.error(JSON.stringify(error)) },
    onCompleted: (data) => {
      if (data) {
        responseErrorHandler(data);
        setSearchResults(data.searchTickets);
        !!setShowModal && setShowModal(false);
      }
    }
  });

  const submitSearch = (searchState, perPage = resultsPerPage, page = 1) => {
    const searchStr = JSON.stringify(searchState);
    searchTickets({ variables: { perPage, page, json: searchStr } });
  };

  return { searchResults, setSearchResults, submitSearch, resultsPerPage, setResultsPerPage, ticketSearchLoading, ticketSearchError };
};
